const OPENING = 'opening'
const OPENED = 'opened'
const CLOSING = 'closing'
const CLOSED = 'closed'

export {
  OPENING,
  OPENED,
  CLOSING,
  CLOSED
}
